import { render, staticRenderFns } from "./LoanExtension.vue?vue&type=template&id=a9a02960"
import script from "./LoanExtension.vue?vue&type=script&lang=js"
export * from "./LoanExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports